import { AnalyticsRoutes } from './analytics';
import { AuthPages } from './auth';
import { ClientsPages } from './clients';
import { DashboardRoutes } from './dashboard';
import { DataPages, DataPagesProductManager } from './data';
import { Devices } from './devices';
import { IRomaScentsPages } from './iRomaScents';
import { LogsPages } from './logs';
import { MarketplaceRoutes } from './marketplace';
import { MyPageRoutes } from './myPage';
import { NotFoundPages } from './notFound';
import { OrdersPages } from './orders';
import { Redirect } from './redirect';
import { ServiceProviderAdminPages, ServiceProviderPages } from './serviceProvider';
import { SettingsPages } from './settings';
import { Routes } from './types';

const RequiredRoutesForAll: Routes = [...AuthPages, ...MyPageRoutes, ...Redirect];

/**
 * TODO: all component replace on lazy(() => import('path/to/component/'));
 */
export const Pages: Routes = [
    ...RequiredRoutesForAll,
    ...DashboardRoutes,
    ...AnalyticsRoutes,
    ...MarketplaceRoutes,
    ...NotFoundPages,
    ...IRomaScentsPages,
    ...ClientsPages,
    ...OrdersPages,
    ...DataPages,
    ...LogsPages,
    ...SettingsPages,
    ...Devices,
    ...ServiceProviderAdminPages,
];

export const PagesForServiceManager: Routes = [...RequiredRoutesForAll, ...MyPageRoutes, ...IRomaScentsPages];

export const PagesForProductManager: Routes = [...RequiredRoutesForAll, ...DataPagesProductManager];

export const PagesForServiceProvider: Routes = [...RequiredRoutesForAll, ...MyPageRoutes, ...IRomaScentsPages, ...ServiceProviderPages];
